export function readFromLS(key) {
  const res = localStorage.getItem(key);
  if (!res || res == "undefined" || res == null) {
    return null;
  } else {
    return JSON.parse(res);
  }
}
export function writeToLS(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}